
import { VueDraggableNext } from 'vue-draggable-next'
import { defineComponent } from 'vue';
import { CodeData } from 'src/services/DiagnosisService';

export default defineComponent({
  components: {
    draggable: VueDraggableNext,
  },
  props: {
    title: String,
    rows: Array<CodeData>,
  }
})
